// extracted by mini-css-extract-plugin
module.exports = {"PasswordResetPhone":"yp_a bhc_px bhc_a bhc_w bhc_cw bhc_sf"};